/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProductDetailImage
 */
export interface AdminProductDetailImage {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailImage
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductDetailImage
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailImage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailImage
     */
    originalPath: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailImage
     */
    thumbnailPath: string;
}

export function AdminProductDetailImageFromJSON(json: any): AdminProductDetailImage {
    return AdminProductDetailImageFromJSONTyped(json, false);
}

export function AdminProductDetailImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetailImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isPrimary': !exists(json, 'isPrimary') ? undefined : json['isPrimary'],
        'name': json['name'],
        'originalPath': json['originalPath'],
        'thumbnailPath': json['thumbnailPath'],
    };
}

export function AdminProductDetailImageToJSON(value?: AdminProductDetailImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'isPrimary': value.isPrimary,
        'name': value.name,
        'originalPath': value.originalPath,
        'thumbnailPath': value.thumbnailPath,
    };
}

